<template>
  <div class="CreateTicketUser">
    <main>
      <div class="page-header pb-10 page-header-dark bg-gradient-primary-to-secondary">
        <div class="container">
          <div class="row">
            <div class="col-md-10 offset-md-1">
              <div class="page-header-content">
                <h1 class="page-header-title">
                  <div class="page-header-icon">
                    <i data-feather="activity"></i>
                  </div>
                  <span>Create a support ticket</span>
                </h1>
                <!--  <div class="page-header-subtitle">Support Ticketing Reports</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n10">
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <transition name="custom-classes-transition" enter-active-class="animated bounceInLeft" leave-active-class="animated bounceOutRight">
              <div class="card bg-light mb-3" v-show="animate">
                <div class="card-body">
                  <CreateForm></CreateForm>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import CreateForm from "@/components/CreateForm";

export default {
  name: "CreateTicketUser",
  data() {
    return {
      animate: false,
    };
  },
  mounted() {
    this.animate = true;
  },
  components: {
    CreateForm,
  },
};
</script>